import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'booksectiontype/';

export const getAllBookSectionTypes = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};